export enum StreamTypeEnum {
  Public = 'Public',
  Local = 'Local',
  None = 'None'
}
